import Swal from "sweetalert2";
import { useStore } from "./store";

// ...yes atleast this is better than pasting the same code over and over yk

export async function fetchAnimes() {
  const { token, setToken, setAnimes } = useStore.getState();

  const animesRequest = await fetch(process.env.REACT_APP_API + "/anime", {
    headers: {
      "authorization": token
    }
  }).catch((err) => {
    console.error(err);
    Swal.fire({
      title: "애니메이션 조회 실패",
      text: err.toString(),
      icon: "error",
      confirmButtonText: "확인"
    });
  });

  if (!animesRequest) return;

  if (animesRequest.status === 200) {
    const animes = await animesRequest.json();
    setAnimes(animes);
    return animes;
  } else if (animesRequest.status === 401) {
    setToken(null);
    Swal.fire({
      title: "애니메이션 조회 실패",
      html: "로그인 정보가 올바르지 않습니다.<br/>다시 로그인해주세요.",
      icon: "error",
      confirmButtonText: "확인"
    });
  } else {
    Swal.fire({
      title: "애니메이션 조회 실패",
      html: await animesRequest.text(),
      icon: "error",
      confirmButtonText: "확인"
    });
  }

  return [];
}

export async function fetchBroadcasts(animeId) {
  const { token, setToken, setBroadcasts } = useStore.getState();

  const broadcastsRequest = await fetch(`${process.env.REACT_APP_API}/anime/${animeId}/broadcasts`, {
    headers: {
      "authorization": token
    }
  }).catch((err) => {
    console.error(err);
    Swal.fire({
      title: "방송 조회 실패",
      text: err.toString(),
      icon: "error",
      confirmButtonText: "확인"
    });
  });

  if (!broadcastsRequest) return;

  if (broadcastsRequest.status === 200) {
    const broadcasts = await broadcastsRequest.json();
    setBroadcasts(broadcasts);
    return broadcasts;
  } else if (broadcastsRequest.status === 401) {
    setToken(null);
    Swal.fire({
      title: "방송 조회 실패",
      html: "로그인 정보가 올바르지 않습니다.<br/>다시 로그인해주세요.",
      icon: "error",
      confirmButtonText: "확인"
    });
  } else {
    Swal.fire({
      title: "방송 조회 실패",
      html: await broadcastsRequest.text(),
      icon: "error",
      confirmButtonText: "확인"
    });
  }

  return [];
}

export async function updateInfo(url, value, title, onSave, method = "PATCH", headers = {}) {
  const { token, setToken } = useStore.getState();

  const successStatus = {
    POST: 201,
    PATCH: 204
  };

  const saveRequest = await fetch(process.env.REACT_APP_API + url, {
    headers: {
      "authorization": token,
      "content-type": "application/json",
      ...headers
    },
    method: method,
    body: typeof value === "object" ? JSON.stringify(value) : value
  }).catch((err) => {
    console.error(err);
    Swal.fire({
      title: title + " 저장 실패",
      text: err.toString(),
      icon: "error",
      confirmButtonText: "확인"
    });
  });

  if (!saveRequest) return;

  if (saveRequest.status === successStatus[method]) {
    onSave();
  } else if (saveRequest.status === 401) {
    setToken(null);
    Swal.fire({
      title: title + " 저장 실패",
      html: "로그인 정보가 올바르지 않습니다.<br/>다시 로그인해주세요.",
      icon: "error",
      confirmButtonText: "확인"
    });
  } else {
    Swal.fire({
      title: title + " 저장 실패",
      text: await saveRequest.text(),
      icon: "error",
      confirmButtonText: "확인"
    });
  }
}

export async function deleteInfo(url, title, onSave) {
  const { token, setToken } = useStore.getState();

  const deleteRequest = await fetch(process.env.REACT_APP_API + url, {
    headers: {
      "authorization": token
    },
    method: "DELETE"
  }).catch((err) => {
    console.error(err);
    Swal.fire({
      title: title + " 삭제 실패",
      text: err.toString(),
      icon: "error",
      confirmButtonText: "확인"
    });
  });

  if (!deleteRequest) return;

  if (deleteRequest.status === 204) {
    onSave();
  } else if (deleteRequest.status === 401) {
    setToken(null);
    Swal.fire({
      title: title + " 삭제 실패",
      html: "로그인 정보가 올바르지 않습니다.<br/>다시 로그인해주세요.",
      icon: "error",
      confirmButtonText: "확인"
    });
  } else {
    Swal.fire({
      title: title + " 삭제 실패",
      text: await deleteRequest.text(),
      icon: "error",
      confirmButtonText: "확인"
    });
  }
}
